import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    serviceTaskFiltersList:{},
    lastVisitedTab: 1,
    showServiceTaskTable: false,
    serviceTaskEditData: {},
    serviceTaskDeleteData: {
        serviceTaskDeleteId: '',
        serviceTaskDeleteMessage: '',
        serviceTaskDelete: false
    },
    editServiceType: "",
}

const serviceTaskSlice = createSlice({
    name: "serviceTask",
    initialState,
    reducers: {
        serviceTaskFiltersListInfo:(state, { payload }) => {
            state.serviceTaskFiltersList = payload;
        },
        lastVisitedTabInfo: (state, { payload }) => {
            state.lastVisitedTab = payload;
        },
        showServiceTaskTableInfo: (state, { payload }) => {
            state.showServiceTaskTable = payload;
        },
        serviceTaskEditDataInfo: (state, { payload }) => {
            state.serviceTaskEditData = payload;
        },
        editServiceTypeInfo: (state, { payload }) => {
            state.editServiceType = payload;
        },
        serviceTaskDeleteDataInfo: (state, { payload }) => {
            state.serviceTaskDeleteData.serviceTaskDeleteId = payload?.serviceTaskDeleteId ? payload?.serviceTaskDeleteId : '';
            state.serviceTaskDeleteData.serviceTaskDeleteMessage = payload?.serviceTaskDeleteMessage ? payload?.serviceTaskDeleteMessage : '';
            state.serviceTaskDeleteData.serviceTaskDelete = payload?.serviceTaskDelete ? payload?.serviceTaskDelete : false;
        },
    }
});

const { reducer, actions } = serviceTaskSlice;

export const { serviceTaskFiltersListInfo, lastVisitedTabInfo, showServiceTaskTableInfo,
    serviceTaskEditDataInfo, editServiceTypeInfo, serviceTaskDeleteDataInfo,
} = actions;

export default reducer;